export const PK10_BALL_COLORS = {
  1: 'linear-gradient(to bottom, #fee40d, #f1d800)',
  2: 'linear-gradient(to bottom, #0d96ff, #0089f2)',
  3: 'linear-gradient(to bottom, #787878, #6b6b6b)',
  4: 'linear-gradient(to bottom, #ffb20d, #f2a500)',
  5: 'linear-gradient(to bottom, #00ddd0, #00ddd0)',
  6: 'linear-gradient(to bottom, #620dff, #5600f2)',
  7: 'linear-gradient(to bottom, #bcbcbc, #afafaf)',
  8: 'linear-gradient(to bottom, #ff0d0d, #f20000)',
  9: 'linear-gradient(to bottom, #ad0d0d, #a10000)',
  10: 'linear-gradient(to bottom, #39ba00, #39ba00)'
}

export const SAMPLE_PK10 = {
  issue: '1002847234',
  codes: [6, 2, 3, 10, 5, 1, 4, 9, 8, 7]
}

const countSumWays = () => {
  const counts = {}
  for (let a = 1; a <= 10; a++) {
    for (let b = 1; b <= 10; b++) {
      if (b === a) continue
      for (let c = 1; c <= 10; c++) {
        if (c === a || c === b) continue
        const s = a + b + c
        counts[s] = (counts[s] || 0) + 1
      }
    }
  }
  return counts
}

const SUM_WAYS = countSumWays()

const toOdds = (ways) => {
  const raw = (720 / ways) * 0.98
  return raw >= 100 ? Math.floor(raw) : Math.round(raw * 10) / 10
}

export const GYJH_OPTIONS = Array.from({ length: 22 }, (_, i) => {
  const num = i + 6
  return { num, odds: toOdds(SUM_WAYS[num]) }
})

const countPairWays = () => {
  const counts = {}
  for (let a = 1; a <= 10; a++) {
    for (let b = 1; b <= 10; b++) {
      if (b === a) continue
      const s = a + b
      counts[s] = (counts[s] || 0) + 1
    }
  }
  return counts
}

const PAIR_WAYS = countPairWays()

const toPairOdds = (ways) => {
  const raw = (90 / ways) * 0.98
  if (raw >= 20) return Math.round(raw)
  return Math.floor(raw * 2) / 2
}

export const GYH_OPTIONS = Array.from({ length: 17 }, (_, i) => {
  const num = i + 3
  return { num, odds: toPairOdds(PAIR_WAYS[num]) }
})

export const getSumPlayType = (playKey) => {
  if (playKey === 'pk10-sum-gyj') return 'gyj'
  if (playKey === 'pk10-sum-sw') return 'sw'
  if (playKey === 'pk10-sum-gy') return 'gy'
  return ''
}

export const PK10_SUM_TABS = [
  { key: 'gy', label: '冠亚和值' },
  { key: 'gyj', label: '冠亚季和值' },
  { key: 'sw', label: '首尾和值' }
]

export const PK10_SUM_MAP = {
  gy: GYH_OPTIONS,
  gyj: GYJH_OPTIONS,
  sw: GYH_OPTIONS
}

const shufflePk10 = (seed, index) => {
  const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  for (let k = arr.length - 1; k > 0; k--) {
    const x = Math.sin(seed * 12.9898 + index * 78.233 + k * 4.1414) * 43758.5453
    const j = Math.abs(Math.floor(x)) % (k + 1)
    const tmp = arr[k]
    arr[k] = arr[j]
    arr[j] = tmp
  }
  return arr
}

export const generatePk10Draws = (gameId, count) => {
  const list = []
  if (gameId === 1802) {
    list.push({ issue: SAMPLE_PK10.issue, codes: [...SAMPLE_PK10.codes] })
  }
  let issue = list.length ? Number(list[list.length - 1].issue) - 1 : 1002845272
  while (list.length < count) {
    list.push({
      issue: String(issue),
      codes: shufflePk10(gameId, list.length)
    })
    issue -= 1
  }
  return list
}

export const periodSeconds = (game) => {
  const p = game?.period || ''
  if (p.includes('即投即开')) return 8
  const m = p.match(/([\d.]+)\s*分钟/)
  if (m) return Math.max(5, Math.round(Number(m[1]) * 60))
  if (p.includes('1天') || p.includes('天/期')) return 5 * 3600 + 15
  return 90
}

const POS_P3 = [
  { name: '百位', index: 0 },
  { name: '十位', index: 1 },
  { name: '个位', index: 2 }
]
const POS_FRONT2 = [
  { name: '万位', index: 0 },
  { name: '千位', index: 1 }
]
const POS_BACK2 = [
  { name: '千位', index: 1 },
  { name: '百位', index: 2 }
]
const POS_P5 = [
  { name: '万位', index: 0 },
  { name: '千位', index: 1 },
  { name: '百位', index: 2 },
  { name: '十位', index: 3 },
  { name: '个位', index: 4 }
]
const POS_P5_BACK2 = [
  { name: '十位', index: 3 },
  { name: '个位', index: 4 }
]
const POS_FRONT3 = [
  { name: '万位', index: 0 },
  { name: '千位', index: 1 },
  { name: '百位', index: 2 }
]
const POS_MID3 = [
  { name: '千位', index: 1 },
  { name: '百位', index: 2 },
  { name: '十位', index: 3 }
]
const POS_BACK3 = [
  { name: '百位', index: 2 },
  { name: '十位', index: 3 },
  { name: '个位', index: 4 }
]
const POS_FRONT4 = POS_P5.slice(0, 4)
const POS_BACK4 = POS_P5.slice(1)

const digitPlay = (playName, positions, extra = {}) => ({
  layout: 'digit',
  mode: extra.mode || 'direct',
  playName,
  positions,
  prize: extra.prize ?? 950,
  showMiss: extra.showMiss ?? false,
  showLimit: true,
  limitText: extra.limitText || '该玩法订单投注上限：800 注',
  unit: extra.unit ?? 2,
  defaultMultiple: extra.defaultMultiple ?? 1,
  quickBelow: extra.quickBelow ?? false,
  fillBalls: extra.fillBalls ?? positions.length,
  /** 开奖球后显示前 fillBalls 位之和（P3 直选/组选和值） */
  showDrawSum: extra.showDrawSum ?? false,
  colored: extra.colored ?? false,
  range: extra.range ?? 10,
  rangeStart: extra.rangeStart ?? 0,
  hideQuick: extra.hideQuick ?? false,
  maxPerRow: extra.maxPerRow ?? 0,
  unique: extra.unique ?? false,
  uniquePick: extra.uniquePick ?? extra.unique ?? false,
  uniqueCount: extra.uniqueCount ?? extra.unique ?? false,
  requireEachRow: extra.requireEachRow ?? false,
  choiceOptions: extra.choiceOptions || null,
  choiceStyle: extra.choiceStyle || null,
  prize2: extra.prize2 || null,
  prizeName: extra.prizeName || null,
  prize2Name: extra.prize2Name || null,
  /** 逐档赔率表：分布型玩法（如 11X5 定单双/猜中位、PCB 和值）按选项文本覆盖 prize */
  prizeByOption: extra.prizeByOption || null,
  /** 筛选栏移到号码球正上方整行展示（如 PK10 猜前二） */
  quickOverGrid: extra.quickOverGrid ?? false
})

const PLAY_SPECS = {
  'p3-zx': digitPlay('P3直选', POS_P3, { showMiss: false }),
  'p3-zx-ds': {
    layout: 'text',
    mode: 'direct',
    playName: 'P3直选（单式）',
    positions: POS_P3,
    prize: 950,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：800 注',
    unit: 2,
    defaultMultiple: 1,
    quickBelow: false,
    fillBalls: 3,
    colored: false,
    range: 10,
    rangeStart: 0,
    textDigits: 3,
    placeholder: '每注之间可以用回车、空格\\n、逗号[,]或者分号[;]、[\\"]隔开，请导入TXT文件、复制或者输入支持格式如下：\n123 456\n123,456\n1+2+3;4+5+6\n1.2.3 4.5.6\n123|456'
  },

  'p3-zx-sum': digitPlay('P3直选和值', [{ name: '和值', index: 0 }], {
    showMiss: false,
    prize: 980,
    range: 28,
    fillBalls: 3,
    showDrawSum: true,
    limitText: '该玩法单列投注上限：800 注'
  }),
  'p3-z3': digitPlay('P3组三', [{ name: '组三', index: 0 }], { showMiss: false, prize: 316, fillBalls: 2, limitText: '该玩法订单投注上限：72 注' }),
  'p3-z6': digitPlay('P3组六', [{ name: '组六', index: 0 }], { showMiss: false, prize: 158, fillBalls: 3, limitText: '该玩法订单投注上限：96 注' }),
  'p3-zx-group-sum': digitPlay('P3组选和值', [{ name: '和值', index: 0 }], {
    showMiss: false,
    prize: 326.66,
    range: 26,
    rangeStart: 1,
    fillBalls: 3,
    showDrawSum: true,
    limitText: '该玩法单列投注上限：168 注'
  }),
  'p3-mix': digitPlay('P3混合组选', POS_P3),
  'p3-1d': digitPlay('P3一码不定位', [{ name: '胆码', index: 0 }], { showMiss: false, hideQuick: true, prize: 3.61, limitText: '该玩法投注上限：8 注' }),
  'p3-2d': digitPlay('P3二码不定位', [{ name: '一胆', index: 0 }, { name: '二胆', index: 1 }], { showMiss: false, hideQuick: true, prize: 34.98, maxPerRow: 1, fillBalls: 2, limitText: '该玩法单列投注上限：80 注' }),
  'front2-zx': digitPlay('前二直选', POS_FRONT2, { prize: 98, limitText: '该玩法订单投注上限：80 注' }),
  'front2-zux': digitPlay('前二组选', [{ name: '组选', index: 0 }], { showMiss: false, prize: 49, fillBalls: 2, limitText: '该玩法订单投注上限：36 注' }),
  'p3-back2-zx': digitPlay('P3后二直选', POS_BACK2, { showMiss: true, prize: 98, limitText: '该玩法订单投注上限：80 注' }),
  'p3-back2-zx-ds': {
    layout: 'text',
    mode: 'direct',
    playName: 'P3后二直选（单式）',
    positions: POS_BACK2,
    prize: 98,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：80 注',
    unit: 2,
    defaultMultiple: 1,
    quickBelow: false,
    fillBalls: 2,
    colored: false,
    range: 10,
    rangeStart: 0,
    textDigits: 2,
    placeholder: '每注之间可以用回车、空格\\n、逗号[,]或者分号[;]、[\\"]隔开，请导入TXT文件、复制或者输入支持格式如下：\n12 34\n12,34\n1+2;3+4\n1.2 3.4\n12|34'
  },
  'p3-back2-zux': digitPlay('P3后二组选', [{ name: '组选', index: 0 }], { showMiss: false, prize: 49, fillBalls: 2, limitText: '该玩法订单投注上限：36 注' }),
  'p5-back2-zx': digitPlay('P5后二直选', POS_P5_BACK2, { showMiss: true, prize: 98, limitText: '该玩法订单投注上限：80 注' }),
  'p5-back2-zx-ds': {
    layout: 'text',
    mode: 'direct',
    playName: 'P5后二直选（单式）',
    positions: POS_P5_BACK2,
    prize: 98,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：80 注',
    unit: 2,
    defaultMultiple: 1,
    quickBelow: false,
    fillBalls: 2,
    colored: false,
    range: 10,
    rangeStart: 0,
    textDigits: 2,
    placeholder: '每注之间可以用回车、空格\\n、逗号[,]或者分号[;]、[\\"]隔开，请导入TXT文件、复制或者输入支持格式如下：\n12 34\n12,34\n1+2;3+4\n1.2 3.4\n12|34'
  },
  'p5-back2-zux': digitPlay('P5后二组选', [{ name: '组选', index: 0 }], { showMiss: false, prize: 49, fillBalls: 2, limitText: '该玩法订单投注上限：36 注' }),
  'front2-dxds': digitPlay('前二大小单双', POS_FRONT2, {
    showMiss: true,
    hideQuick: true,
    prize: 3.92,
    limitText: '该玩法订单投注上限：12 注',
    maxPerRow: 1,
    fillBalls: 2,
    choiceOptions: ['大', '小', '单', '双']
  }),
  'p3-back2-dxds': digitPlay('P3后二大小单双', POS_BACK2, {
    showMiss: true,
    hideQuick: true,
    prize: 3.92,
    limitText: '该玩法订单投注上限：12 注',
    maxPerRow: 1,
    fillBalls: 2,
    choiceOptions: ['大', '小', '单', '双']
  }),
  'p5-back2-dxds': digitPlay('P5后二大小单双', POS_P5_BACK2, {
    showMiss: true,
    hideQuick: true,
    prize: 3.92,
    limitText: '该玩法订单投注上限：12 注',
    maxPerRow: 1,
    fillBalls: 2,
    choiceOptions: ['大', '小', '单', '双']
  }),
  'lf-dw': digitPlay('定位胆', POS_P5, { mode: 'position', showMiss: true, prize: 9.8, limitText: '该玩法单列投注上限：8 注' }),
  'ssc-wx': digitPlay('五星直选', POS_P5, { prize: 95000 }),
  'ssc-q4': digitPlay('前四直选', POS_FRONT4, { prize: 9500 }),
  'ssc-h4': digitPlay('后四直选', POS_BACK4, { prize: 9500 }),
  'ssc-q3': digitPlay('前三直选', POS_FRONT3, { prize: 950 }),
  'ssc-z3': digitPlay('中三直选', POS_MID3, { prize: 950 }),
  'ssc-h3': digitPlay('后三直选', POS_BACK3, { prize: 950 }),
  'ssc-q2': digitPlay('前二直选', POS_FRONT2, { prize: 98 }),
  'ssc-h2': digitPlay('后二直选', POS_P5_BACK2, { prize: 98 }),
  'ssc-bdw': digitPlay('一码不定位', [{ name: '不定位', index: 0 }], { prize: 3.6, hideQuick: true }),
  'ssc-rx2': digitPlay('任二直选', POS_FRONT2, { prize: 98 }),
  'ssc-dxds': digitPlay('前二大小单双', POS_FRONT2, { prize: 3.9, hideQuick: true, choiceOptions: ['大', '小', '单', '双'] }),
  'ssc-nn': digitPlay('牛牛', [{ name: '牛牛', index: 0 }], { prize: 9.8, hideQuick: true, choiceOptions: ['无牛', '牛一', '牛二', '牛三', '牛四', '牛五', '牛六', '牛七', '牛八', '牛九', '牛牛'] }),
  'ssc-hk5': digitPlay('炸金花', [{ name: '牌型', index: 0 }], { prize: 9.8, hideQuick: true, choiceOptions: ['豹子', '顺金', '金花', '顺子', '对子', '散牌'] }),
  'ssc-bjl': digitPlay('百家乐', [{ name: '百家乐', index: 0 }], { prize: 1.96, hideQuick: true, choiceOptions: ['庄', '闲', '和'] }),
  'ssc-five1': digitPlay('全五中一', [{ name: '全五中一', index: 0 }], { prize: 1.96 }),
  'ssc-dw': digitPlay('定位胆', POS_P5, {
    mode: 'position',
    prize: 98,
    unit: 1,
    defaultMultiple: 10,
    quickBelow: true,
    fillBalls: 5,
    limitText: '该玩法单列投注上限：8 注'
  }),
  'ssc-b1': digitPlay('第一球直选', [{ name: '第一球', index: 0 }], { prize: 9.8 }),
  'ssc-b1-dxds': digitPlay('第一球大小单双', [{ name: '第一球', index: 0 }], {
    hideQuick: true,
    prize: 1.96,
    choiceOptions: ['大', '小', '单', '双']
  }),
  'ssc-b2': digitPlay('第二球直选', [{ name: '第二球', index: 1 }], { prize: 9.8 }),
  'ssc-b2-dxds': digitPlay('第二球大小单双', [{ name: '第二球', index: 1 }], { hideQuick: true, prize: 1.96, choiceOptions: ['大', '小', '单', '双'] }),
  'ssc-b3': digitPlay('第三球直选', [{ name: '第三球', index: 2 }], { prize: 9.8 }),
  'ssc-b3-dxds': digitPlay('第三球大小单双', [{ name: '第三球', index: 2 }], { hideQuick: true, prize: 1.96, choiceOptions: ['大', '小', '单', '双'] }),
  'ssc-b4': digitPlay('第四球直选', [{ name: '第四球', index: 3 }], { prize: 9.8 }),
  'ssc-b4-dxds': digitPlay('第四球大小单双', [{ name: '第四球', index: 3 }], { hideQuick: true, prize: 1.96, choiceOptions: ['大', '小', '单', '双'] }),
  'ssc-b5': digitPlay('第五球直选', [{ name: '第五球', index: 4 }], { prize: 9.8 }),
  'ssc-b5-dxds': digitPlay('第五球大小单双', [{ name: '第五球', index: 4 }], { hideQuick: true, prize: 1.96, choiceOptions: ['大', '小', '单', '双'] }),
  'ssc-ent-dxds': digitPlay('总大小单双', [{ name: '总和', index: 0 }], {
    hideQuick: true,
    prize: 1.96,
    choiceOptions: ['总大', '总小', '总单', '总双']
  }),
  'ssc-dt-12': digitPlay('第一球vs第二球', [{ name: '龙虎', index: 0 }], {
    hideQuick: true,
    prize: 1.96,
    choiceOptions: ['龙', '虎', '和']
  }),
  'k3-sum': digitPlay('和值', [{ name: '和值', index: 0 }], { prize: 9.8, range: 16, rangeStart: 3, hideQuick: true }),
  'k3-same3': digitPlay('三同号', [{ name: '三同号', index: 0 }], { prize: 150, hideQuick: true, choiceOptions: ['111', '222', '333', '444', '555', '666'] }),
  'k3-same2': digitPlay('二同号', [{ name: '二同号', index: 0 }], { prize: 50, hideQuick: true, choiceOptions: ['11', '22', '33', '44', '55', '66'] }),
  'k3-diff3': digitPlay('三不同号', [{ name: '三不同', index: 0 }], { prize: 30, range: 6, rangeStart: 1, fillBalls: 3 }),
  'k3-diff2': digitPlay('二不同号', [{ name: '二不同', index: 0 }], { prize: 6, range: 6, rangeStart: 1, fillBalls: 2 }),
  'k3-straight': digitPlay('三连号通选', [{ name: '三连号', index: 0 }], { prize: 8, hideQuick: true, choiceOptions: ['通选'] }),
  // 11X5 赔率按 RTP 0.92 反推（P 见注释；x5-dds / x5-mid 为分布型，走 prizeByOption 逐档表）
  'x5-q3-zx': digitPlay('前三直选', [{ name: '第一位', index: 0 }, { name: '第二位', index: 1 }, { name: '第三位', index: 2 }], { prize: 910.8, range: 11, rangeStart: 1 }), // P=1/990
  'x5-q3-zux': digitPlay('前三组选', [{ name: '组选', index: 0 }], { prize: 151.8, range: 11, rangeStart: 1, fillBalls: 3 }), // P=1/165
  'x5-q2-zx': digitPlay('前二直选', [{ name: '第一位', index: 0 }, { name: '第二位', index: 1 }], { prize: 101.2, range: 11, rangeStart: 1 }), // P=1/110
  'x5-q2-zux': digitPlay('前二组选', [{ name: '组选', index: 0 }], { prize: 50.6, range: 11, rangeStart: 1, fillBalls: 2 }), // P=1/55
  'x5-bdw': digitPlay('前三不定位', [{ name: '不定位', index: 0 }], { prize: 3.37, range: 11, rangeStart: 1 }), // P=3/11
  'x5-dw': digitPlay('定位胆', [{ name: '第一位', index: 0 }, { name: '第二位', index: 1 }, { name: '第三位', index: 2 }, { name: '第四位', index: 3 }, { name: '第五位', index: 4 }], { mode: 'position', prize: 10.12, range: 11, rangeStart: 1 }), // P=1/11
  'x5-r1': digitPlay('任选一', [{ name: '任选一', index: 0 }], { prize: 2.02, range: 11, rangeStart: 1 }), // P=5/11
  'x5-r2': digitPlay('任选二', [{ name: '任选二', index: 0 }], { prize: 5.06, range: 11, rangeStart: 1, fillBalls: 2 }), // P=C(9,3)/C(11,5)
  'x5-r3': digitPlay('任选三', [{ name: '任选三', index: 0 }], { prize: 15.18, range: 11, rangeStart: 1, fillBalls: 3 }), // P=C(8,2)/C(11,5)
  'x5-r4': digitPlay('任选四', [{ name: '任选四', index: 0 }], { prize: 60.72, range: 11, rangeStart: 1, fillBalls: 4 }), // P=C(7,1)/C(11,5)
  'x5-r5': digitPlay('任选五', [{ name: '任选五', index: 0 }], { prize: 425, range: 11, rangeStart: 1, fillBalls: 5 }), // P=1/C(11,5)
  'x5-dds': digitPlay('定单双', [{ name: '定单双', index: 0 }], {
    prize: 2.13, hideQuick: true,
    choiceOptions: ['5单0双', '4单1双', '3单2双', '2单3双', '1单4双', '0单5双'],
    // 分布型：5 球中单数个数不服从均匀分布，逐档配赔（RTP 0.92）
    prizeByOption: { '5单0双': 425, '4单1双': 14.17, '3单2双': 2.83, '2单3双': 2.13, '1单4双': 5.67, '0单5双': 70.84 }
  }),
  'x5-mid': digitPlay('猜中位', [{ name: '猜中位', index: 0 }], {
    prize: 4.25, range: 11, rangeStart: 1, hideQuick: true,
    // 中位数仅 3~9 可能出现，逐档配赔（RTP 0.92）
    prizeByOption: { '3': 15.18, '4': 6.75, '5': 4.72, '6': 4.25, '7': 4.72, '8': 6.75, '9': 15.18 }
  }),
  'x5-b1': digitPlay('第一球', [{ name: '第一球', index: 0 }], { prize: 10.12, range: 11, rangeStart: 1 }), // P=1/11
  'x5-two': digitPlay('两面', [{ name: '两面', index: 0 }], { prize: 1.84, hideQuick: true, choiceOptions: ['大', '小', '单', '双'] }), // P=0.5
  'lhc-tm': digitPlay('特码', [{ name: '特码', index: 0 }], { prize: 48.02, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-zm': digitPlay('正码', [{ name: '正码', index: 0 }], { prize: 8, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-lm-2': digitPlay('二全中', [{ name: '二全中', index: 0 }], { prize: 75, range: 49, rangeStart: 1, fillBalls: 2, hideQuick: true }),
  'lhc-lm-3': digitPlay('三全中', [{ name: '三全中', index: 0 }], { prize: 700, range: 49, rangeStart: 1, fillBalls: 3, hideQuick: true }),
  'lhc-lm-4': digitPlay('四全中', [{ name: '四全中', index: 0 }], { prize: 5000, range: 49, rangeStart: 1, fillBalls: 4, hideQuick: true }),
  'lhc-sx': digitPlay('特肖', [{ name: '生肖', index: 0 }], { prize: 12, hideQuick: true, choiceOptions: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'] }),
  'lhc-sb': digitPlay('色波', [{ name: '色波', index: 0 }], { prize: 2.8, hideQuick: true, choiceOptions: ['红波', '蓝波', '绿波'] }),
  'lhc-tm-dxds': digitPlay('特码两面', [{ name: '特码两面', index: 0 }], { prize: 1.96, hideQuick: true, choiceOptions: ['大', '小', '单', '双'] }),
  'lhc-tw': digitPlay('头尾数', [{ name: '头尾', index: 0 }], { prize: 9.8, hideQuick: true, choiceOptions: ['0头', '1头', '2头', '3头', '4头', '0尾', '1尾', '2尾', '3尾', '4尾', '5尾', '6尾', '7尾', '8尾', '9尾'] }),
  'lhc-hx': digitPlay('合肖', [{ name: '合肖', index: 0 }], { prize: 9.8, hideQuick: true, choiceOptions: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'] }),
  'lhc-zm16': digitPlay('正码1-6', [{ name: '正码1-6', index: 0 }], { prize: 1.96, hideQuick: true }),
  'lhc-zm1': digitPlay('正码一', [{ name: '正码一', index: 0 }], { prize: 48.02, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-zm2': digitPlay('正码二', [{ name: '正码二', index: 1 }], { prize: 48.02, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-zm3': digitPlay('正码三', [{ name: '正码三', index: 2 }], { prize: 48.02, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-zm4': digitPlay('正码四', [{ name: '正码四', index: 3 }], { prize: 48.02, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-zm5': digitPlay('正码五', [{ name: '正码五', index: 4 }], { prize: 48.02, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-zm6': digitPlay('正码六', [{ name: '正码六', index: 5 }], { prize: 48.02, range: 49, rangeStart: 1, hideQuick: true }),
  'lhc-lm-2z2': digitPlay('二中特', [{ name: '二中特', index: 0 }], { prize: 51, prizeName: '中特', prize2: 150, prize2Name: '中二', range: 49, rangeStart: 1, fillBalls: 2, hideQuick: true }),
  'lhc-lm-3z2': digitPlay('三中二', [{ name: '三中二', index: 0 }], { prize: 21, prizeName: '中二', prize2: 88, prize2Name: '中三', range: 49, rangeStart: 1, fillBalls: 3, hideQuick: true }),
  'lhc-lm-t2': digitPlay('特串', [{ name: '特串', index: 0 }], { prize: 150, range: 49, rangeStart: 1, fillBalls: 2, hideQuick: true }),
  'lhc-zx': digitPlay('自选不中', [{ name: '自选不中', index: 0 }], { prize: 0, range: 49, rangeStart: 1, fillBalls: 5, hideQuick: true }),
  'lhc-zx6': digitPlay('六不中', [{ name: '六不中', index: 0 }], { prize: 4.5, range: 49, rangeStart: 1, fillBalls: 6, hideQuick: true }),
  'lhc-zx7': digitPlay('七不中', [{ name: '七不中', index: 0 }], { prize: 8, range: 49, rangeStart: 1, fillBalls: 7, hideQuick: true }),
  'lhc-zx8': digitPlay('八不中', [{ name: '八不中', index: 0 }], { prize: 13, range: 49, rangeStart: 1, fillBalls: 8, hideQuick: true }),
  'lhc-zx9': digitPlay('九不中', [{ name: '九不中', index: 0 }], { prize: 22, range: 49, rangeStart: 1, fillBalls: 9, hideQuick: true }),
  'lhc-zx10': digitPlay('十不中', [{ name: '十不中', index: 0 }], { prize: 38, range: 49, rangeStart: 1, fillBalls: 10, hideQuick: true }),
  'lhc-zx11': digitPlay('十一不中', [{ name: '十一不中', index: 0 }], { prize: 65, range: 49, rangeStart: 1, fillBalls: 11, hideQuick: true }),
  'lhc-zx12': digitPlay('十二不中', [{ name: '十二不中', index: 0 }], { prize: 120, range: 49, rangeStart: 1, fillBalls: 12, hideQuick: true }),
  'lhc-lx2': digitPlay('二连肖', [{ name: '二连肖', index: 0 }], { prize: 4.6, hideQuick: true, fillBalls: 2, choiceOptions: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'] }),
  'lhc-lx3': digitPlay('三连肖', [{ name: '三连肖', index: 0 }], { prize: 18, hideQuick: true, fillBalls: 3, choiceOptions: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'] }),
  'lhc-lx4': digitPlay('四连肖', [{ name: '四连肖', index: 0 }], { prize: 80, hideQuick: true, fillBalls: 4, choiceOptions: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'] }),
  'lhc-lx5': digitPlay('五连肖', [{ name: '五连肖', index: 0 }], { prize: 400, hideQuick: true, fillBalls: 5, choiceOptions: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'] }),
  'lhc-ptx': digitPlay('平特一肖', [{ name: '平特一肖', index: 0 }], { prize: 2.05, hideQuick: true }),
  'lhc-ptw': digitPlay('平特尾数', [{ name: '平特尾数', index: 0 }], { prize: 1.76, hideQuick: true }),
  'keno-r1': digitPlay('任选一', [{ name: '任选一', index: 0 }], { prize: 3.68, range: 80, rangeStart: 1, hideQuick: true }), // P=C(20,1)/C(80,1)=1/4
  'keno-r2': digitPlay('任选二', [{ name: '任选二', index: 0 }], { prize: 15.3, range: 80, rangeStart: 1, fillBalls: 2, hideQuick: true }), // P=C(20,2)/C(80,2)
  'keno-r3': digitPlay('任选三', [{ name: '任选三', index: 0 }], { prize: 66.3, range: 80, rangeStart: 1, fillBalls: 3, hideQuick: true }), // P=C(20,3)/C(80,3)
  'keno-updown': digitPlay('上下盘', [{ name: '上下盘', index: 0 }], { prize: 1.84, hideQuick: true, choiceOptions: ['上盘', '中盘', '下盘'] }),
  'keno-oe': digitPlay('奇偶盘', [{ name: '奇偶盘', index: 0 }], { prize: 1.84, hideQuick: true, choiceOptions: ['奇盘', '和盘', '偶盘'] }),
  'pcb-sum': digitPlay('和值', [{ name: '和值', index: 0 }], {
    prize: 12.27, range: 28, hideQuick: true,
    // 3 个 0-9 之和共 1000 种组合，呈钟形分布；逐档配赔保证每档 RTP≈0.92
    prizeByOption: {
      '0': 920, '1': 306.67, '2': 153.33, '3': 92, '4': 61.33, '5': 43.81, '6': 32.86,
      '7': 25.56, '8': 20.44, '9': 16.73, '10': 14.6, '11': 13.33, '12': 12.6,
      '13': 12.27, '14': 12.27, '15': 12.6, '16': 13.33, '17': 14.6, '18': 16.73,
      '19': 20.44, '20': 25.56, '21': 32.86, '22': 43.81, '23': 61.33, '24': 92,
      '25': 153.33, '26': 306.67, '27': 920
    }
  }),
  'pcb-dxds': digitPlay('大小单双', [{ name: '两面', index: 0 }], { prize: 1.84, hideQuick: true, choiceOptions: ['大', '小', '单', '双'] }), // P=0.5
  'pcb-combo': digitPlay('组合大小单双', [{ name: '组合', index: 0 }], {
    prize: 3.42, hideQuick: true,
    choiceOptions: ['大单', '大双', '小单', '小双'],
    // 和值奇偶与大小交叉后并非各 1/4，逐档配赔（RTP 0.92）
    prizeByOption: { '大单': 3.98, '大双': 3.42, '小单': 3.42, '小双': 3.98 }
  }),
  'pk10-front1': digitPlay('猜前一', [{ name: '冠军', index: 0 }], {
    prize: 9.8,
    range: 10,
    rangeStart: 1,
    showMiss: true,
    limitText: '该玩法订单投注上限：8 注'
  }),
  'pk10-front2': digitPlay('猜前二', [{ name: '冠军', index: 0 }, { name: '亚军', index: 1 }], {
    prize: 88.2,
    range: 10,
    rangeStart: 1,
    showMiss: true,
    unique: true,
    quickOverGrid: true,
    limitText: '该玩法订单投注上限：72 注'
  }),
  'pk10-front2-ds': {
    layout: 'text',
    mode: 'direct',
    playName: '猜前二 (单式)',
    positions: [{ name: '冠军', index: 0 }, { name: '亚军', index: 1 }],
    prize: 88.2,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：72 注',
    unit: 2,
    defaultMultiple: 1,
    quickBelow: false,
    fillBalls: 2,
    colored: false,
    range: 10,
    rangeStart: 1,
    textDigits: 2,
    placeholder: '每注之间可以用回车、空格、逗号[,]或者分号[;]、[|]隔开，请导入TXT文件、复制或者输入支持格式如下：\n0102,0304\n01 02;03 04\n01+02,03+04\n01.02,03.04\n0102|0304'
  },
  'pk10-front3': digitPlay('猜前三', [{ name: '冠军', index: 0 }, { name: '亚军', index: 1 }, { name: '季军', index: 2 }], {
    prize: 705,
    range: 10,
    rangeStart: 1,
    showMiss: true,
    unique: false,
    fillBalls: 3,
    limitText: '该玩法订单投注上限：576 注'
  }),
  'pk10-front3-ds': {
    layout: 'text',
    mode: 'direct',
    playName: '猜前三（单式）',
    positions: [{ name: '冠军', index: 0 }, { name: '亚军', index: 1 }, { name: '季军', index: 2 }],
    prize: 705,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：576 注',
    unit: 2,
    defaultMultiple: 1,
    quickBelow: false,
    fillBalls: 3,
    colored: false,
    range: 10,
    rangeStart: 1,
    textDigits: 3,
    placeholder: '每注之间可以用回车、空格、逗号[,]或者分号[;]、[|]隔开，请导入TXT文件、复制或者输入支持格式如下：\n010203,040506\n01 02 03;04 05 06\n01+02+03,04+05+06\n01.02.03,04.05.06\n010203|040506'
  },
  'pk10-front4': digitPlay('猜前四', [
    { name: '冠军', index: 0 },
    { name: '亚军', index: 1 },
    { name: '季军', index: 2 },
    { name: '第四名', index: 3 }
  ], {
    prize: 4900,
    range: 10,
    rangeStart: 1,
    showMiss: true,
    unique: false,
    uniquePick: false,
    uniqueCount: false,
    fillBalls: 4,
    requireEachRow: true,
    limitText: '该玩法订单投注上限：4032 注'
  }),
  'pk10-front4-ds': {
    layout: 'text',
    mode: 'direct',
    playName: '猜前四 (单式)',
    positions: [{ name: '冠军', index: 0 }, { name: '亚军', index: 1 }, { name: '季军', index: 2 }, { name: '第四名', index: 3 }],
    prize: 4900,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：4032 注',
    unit: 2,
    defaultMultiple: 1,
    quickBelow: false,
    fillBalls: 4,
    colored: false,
    range: 10,
    rangeStart: 1,
    textDigits: 4,
    placeholder: '每注之间可以用回车、逗号[,]或者分号[;]、[|]隔开，请导入TXT文件、复制或者输入支持格式如下：\n01020304,05060708\n01 02 03 04;05 06 07 08\n01+02+03+04,05+06+07+08\n01.02.03.04,05.06.07.08\n01 02 03 04|05 06 07 08'
  },
  'pk10-front5': digitPlay('猜前五', [
    { name: '冠军', index: 0 },
    { name: '亚军', index: 1 },
    { name: '季军', index: 2 },
    { name: '第四名', index: 3 },
    { name: '第五名', index: 4 }
  ], {
    prize: 29000,
    range: 10,
    rangeStart: 1,
    showMiss: true,
    unique: false,
    uniquePick: false,
    uniqueCount: false,
    requireEachRow: true,
    fillBalls: 5,
    limitText: '该玩法订单投注上限：24192 注'
  }),
  'pk10-front5-ds': {
    layout: 'text',
    mode: 'direct',
    playName: '猜前五（单式）',
    positions: [{ name: '冠军', index: 0 }, { name: '亚军', index: 1 }, { name: '季军', index: 2 }, { name: '第四名', index: 3 }, { name: '第五名', index: 4 }],
    prize: 30000,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：80 注',
    unit: 2,
    defaultMultiple: 1,
    quickBelow: false,
    fillBalls: 5,
    colored: true,
    range: 10,
    rangeStart: 1,
    textDigits: 5,
    placeholder: '每注五个号码，01-10，可用空格、逗号或回车隔开\n01 02 03 04 05'
  },
  'pk10-dw-front5': digitPlay('前五定位胆', [
    { name: '冠军', index: 0 },
    { name: '亚军', index: 1 },
    { name: '季军', index: 2 },
    { name: '第四名', index: 3 },
    { name: '第五名', index: 4 }
  ], {
    mode: 'position',
    prize: 9.8,
    range: 10,
    rangeStart: 1,
    showMiss: true,
    colored: false,
    fillBalls: 1,
    limitText: '该玩法单列投注上限：8 注'
  }),
  'pk10-dw-back5': digitPlay('后五定位胆', [
    { name: '第六名', index: 5 },
    { name: '第七名', index: 6 },
    { name: '第八名', index: 7 },
    { name: '第九名', index: 8 },
    { name: '第十名', index: 9 }
  ], {
    mode: 'position',
    prize: 9.8,
    range: 10,
    rangeStart: 1,
    showMiss: true,
    colored: false,
    fillBalls: 1,
    limitText: '该玩法单列投注上限：8 注'
  }),
  'pk10-sum-gy': {
    layout: 'sum',
    playName: '冠亚和值',
    posName: '冠亚和',
    options: GYH_OPTIONS,
    cols: 4,
    prize: GYH_OPTIONS[0].odds,
    showMiss: false,
    showLimit: false,
    unit: 2,
    defaultMultiple: 1,
    sumType: 'gy',
    colored: true
  },
  'pk10-sum-gyj': {
    layout: 'sum',
    playName: '冠亚季和值',
    posName: '冠亚季和',
    options: GYJH_OPTIONS,
    cols: 4,
    prize: GYJH_OPTIONS[0].odds,
    showMiss: false,
    showLimit: false,
    unit: 2,
    defaultMultiple: 1,
    sumType: 'gyj',
    colored: true
  },
  'pk10-sum-sw': {
    layout: 'sum',
    playName: '首尾和值',
    posName: '首尾和',
    options: GYH_OPTIONS,
    cols: 4,
    prize: GYH_OPTIONS[0].odds,
    showMiss: false,
    showLimit: false,
    unit: 2,
    defaultMultiple: 1,
    sumType: 'sw',
    colored: true
  },
  'pk10-dxds-front5': digitPlay('前五大小单双', [{ name: '冠军', index: 0 }, { name: '亚军', index: 1 }, { name: '季军', index: 2 }, { name: '第四名', index: 3 }, { name: '第五名', index: 4 }], {
    mode: 'position',
    hideQuick: true,
    showMiss: true,
    prize: 1.96,
    choiceOptions: ['大', '小', '单', '双']
  }),
  'pk10-dxds-back5': digitPlay('后五大小单双', [{ name: '第六名', index: 5 }, { name: '第七名', index: 6 }, { name: '第八名', index: 7 }, { name: '第九名', index: 8 }, { name: '第十名', index: 9 }], {
    mode: 'position',
    hideQuick: true,
    showMiss: true,
    prize: 1.96,
    choiceOptions: ['大', '小', '单', '双']
  }),
  'pk10-dxds-gy': digitPlay('冠亚和大小单双', [{ name: '冠亚和', index: 0 }], {
    mode: 'position',
    hideQuick: true,
    prize: 1.96,
    choiceOptions: ['大', '小', '单', '双']
  }),
  'pk10-dt-1v10': digitPlay('第一名VS第十名', [{ name: '第一名VS第十名', index: 0 }], { mode: 'position', hideQuick: true, prize: 1.96, choiceOptions: ['龙', '虎'], choiceStyle: 'dt' }),
  'pk10-dt-2v9': digitPlay('第二名VS第九名', [{ name: '第二名VS第九名', index: 0 }], { mode: 'position', hideQuick: true, prize: 1.96, choiceOptions: ['龙', '虎'], choiceStyle: 'dt' }),
  'pk10-dt-3v8': digitPlay('第三名VS第八名', [{ name: '第三名VS第八名', index: 0 }], { mode: 'position', hideQuick: true, prize: 1.96, choiceOptions: ['龙', '虎'], choiceStyle: 'dt' }),
  'pk10-dt-4v7': digitPlay('第四名VS第七名', [{ name: '第四名VS第七名', index: 0 }], { mode: 'position', hideQuick: true, prize: 1.96, choiceOptions: ['龙', '虎'], choiceStyle: 'dt' }),
  'pk10-dt-5v6': digitPlay('第五名VS第六名', [{ name: '第五名VS第六名', index: 0 }], { mode: 'position', hideQuick: true, prize: 1.96, choiceOptions: ['龙', '虎'], choiceStyle: 'dt' })
}

export const PLAY_HELP = {
  'pk10-front1': {
    title: '猜前一',
    desc: '从冠军投注的1个号码与开奖号码中的第1位数字号码相同，视为中奖。',
    example: '如：投注方案01，开奖号码：01**********，即中猜前一。'
  },
  'pk10-front2': {
    title: '猜前二',
    desc: '从冠军、亚军投注的两个号码与开奖号码中的前2个号码相同且顺序一致，视为中奖。',
    example: '如：投注方案01、02，开奖号码：01、02********，即中猜前二。'
  },
  'pk10-front2-ds': {
    title: '猜前二',
    desc: '从冠军、亚军投注的两个号码与开奖号码中的前2个号码相同且顺序一致，视为中奖。',
    example: '如：投注方案01、02，开奖号码：01、02********，即中猜前二。'
  },
  'pk10-front3': {
    title: '猜前三',
    desc: '从冠军、亚军、季军投注的三个号码与开奖号码中的前3个号码相同且顺序一致，视为中奖。',
    example: '如：冠军、亚军、季军位买 01、02、03，开奖号码码：冠军、亚军、季军开01、02、03*******，即中猜前三。'
  },
  'pk10-front3-ds': {
    title: '猜前三（单式）',
    desc: '从冠军、亚军、季军投注的三个号码与开奖号码中的前3个号码相同且顺序一致，视为中奖。',
    example: '如：冠军、亚军、季军位买 01、02、03，开奖号码：冠军、亚军、季军开01、02、03*******，即中猜前三。'
  },
  'pk10-front4': {
    title: '猜前四',
    desc: '从冠军、亚军、季军、第四名中选择一个4位数字号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。',
    example: '如：投注01、02、03、04，开奖号码：01、02、03、04 ******，即中猜前四。'
  },
  'pk10-front4-ds': {
    title: '猜前四（单式）',
    desc: '从冠军、亚军、季军、第四名中选择一个4位数字号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。',
    example: '如：投注01、02、03、04，开奖号码：01、02、03、04 ******，即中猜前四。'
  },
  'pk10-front5': {
    title: '猜前五',
    desc: '从冠军、亚军、季军、第四名、第五名中选择一个5位数字号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。',
    example: '如：投注01、02、03、04、05，开奖号码：01、02、03、04、05 ****，即中猜前五。'
  },
  'pk10-front5-ds': {
    title: '猜前五（单式）',
    desc: '手动输入冠军至第五名号码组成1注，所选号码与开奖号码的前五位相同且顺序一致，视为中奖。',
    example: '如：投注方案01 02 03 04 05，开奖号码：0102030405**，即中猜前五。'
  },
  'pk10-dw-front5': {
    title: '前五定位胆',
    desc: '从冠军位开始选择最少一个，最多十个位置，任意1个位置或者多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致，即为中奖。',
    example: '如：投注方案 01（冠军），开奖号码：01**********，即中定位胆。'
  },
  'pk10-dw-back5': {
    title: '后五定位胆',
    desc: '从第六名开始选择最少一个，最多十个位置，任意1个位置或者多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致，即为中奖。',
    example: '如：投注方案 01（第六名），开奖号码：*****01*****，即中定位胆。'
  },
  'pk10-sum-gy': {
    title: '冠亚和值',
    desc: '从3-19中任意选择至少一个号码组成一组，开奖号码前两位之和与所选的号码一致即为中奖，顺序不限。',
    example: '如：投注3，开奖号码：0102********，即中冠亚和值。'
  },
  'pk10-sum-gyj': {
    title: '冠亚季和值',
    desc: '从6-27中任意选择至少一个号码组成一组，开奖号码前三位之和与所选的号码一致即为中奖，顺序不限。',
    example: '如：投注8，开奖号码：01、02、05******，即中冠亚季和值。'
  },
  'pk10-sum-sw': {
    title: '首尾和值',
    desc: '从3-19中任意选择至少一个号码组成一组，开奖号码冠军和第十名之和与所选的号码一致即为中奖，顺序不限。',
    example: '如：投注8，开奖号码：02*******06，即首尾和值。'
  },
  'pk10-dxds-front5': {
    title: '前五大小单双',
    desc: '对冠军至第五名分别投注大、小、单、双。号码1～5为小，6～10为大；单数为单，双数为双。',
    example: '如：冠军投注“大”，开奖冠军为08，即中奖。'
  },
  'pk10-dxds-back5': {
    title: '后五大小单双',
    desc: '对第六名至第十名分别投注大、小、单、双。号码1～5为小，6～10为大；单数为单，双数为双。',
    example: '如：第六名投注“双”，开奖第六名为08，即中奖。'
  },
  'pk10-dxds-gy': {
    title: '冠亚和大小单双',
    desc: '以冠军+亚军的和值投注大、小、单、双。和值3～11为小，12～19为大；单数为单，双数为双。',
    example: '如：开奖冠军08、亚军09，和值为17，投注“大”或“单”即中奖。'
  },
  'pk10-dt-1v10': {
    title: '第一名VS第十名',
    desc: '龙虎是由两两名次进行号码PK，冠军、亚军、第三名、第四名、第五名为龙，第六名、第七名、第八名、第九名、第十名为虎，若冠军车号大于第十名，则为龙，反之则为虎..以此类推。',
    example: '如投注举例：投注第一名VS第十名，投注内容：[龙]，开奖结果第一名为05，第十名为04，即为中奖。'
  },
  'pk10-dt-2v9': {
    title: '第二名VS第九名',
    desc: '龙虎是由两两名次进行号码PK，冠军、亚军、第三名、第四名、第五名为龙，第六名、第七名、第八名、第九名、第十名为虎，若亚军车号大于第九名，则为龙，反之则为虎..以此类推。',
    example: '如投注举例：投注第二名VS第九名，投注内容：[龙],开奖结果第二名为05，第九名为04，即为中奖。'
  },
  'pk10-dt-3v8': {
    title: '第三名vs第八名',
    desc: '龙虎是由两两名次进行号码PK，冠军、亚军、第三名、第四名、第五名为龙，第六名、第七名、第八名、第九名、第十名为虎，若第三名车号大于第八名，则为龙，反之则为虎..以此类推。',
    example: '如投注举例：投注第三名VS第八名，投注内容：[龙], 开奖结果第三名为05，第八名为04，即为中奖。'
  },
  'pk10-dt-4v7': {
    title: '第四名VS第七名',
    desc: '龙虎是由两两名次进行号码PK，冠军、亚军、第三名、第四名、第五名为龙，第六名、第七名、第八名、第九名、第十名为虎，若第四名车号大于第七名，则为龙，反之则为虎..以此类推。',
    example: '如投注举例：投注第四名VS第七名，投注内容：[龙],开奖结果第四名为05，第七名为04，即为中奖。'
  },
  'pk10-dt-5v6': {
    title: '第五名VS第六名',
    desc: '龙虎是由两两名次进行号码PK，冠军、亚军、第三名、第四名、第五名为龙，第六名、第七名、第八名、第九名、第十名为虎，若第五名车号大于第六名，则为龙，反之则为虎..以此类推。',
    example: '如投注举例：投注第五名VS第六名，投注内容：[龙]，开奖结果第五名为05，第六名为04，即为中奖。'
  },
  'pk10-ent-快捷': {
    title: '快捷',
    desc: '可同时勾选名次与号码（或大小单双），每个名次与每个选项组合为1注，对应开奖名次相符即中奖。',
    example: '如：勾选冠军并投注08，开奖第一名为08，即中奖。'
  },
  'pk10-ent-两面': {
    title: '两面',
    desc: '对指定名次投注大、小、单、双。号码1～5为小，6～10为大；单数为单，双数为双。',
    example: '如：冠军投注“大”，开奖冠军为08，即中奖。'
  },
  'pk10-ent-猜和值': {
    title: '猜和值',
    desc: '投注冠亚和值（3～19）或冠亚和的大小单双，与开奖冠军+亚军之和相符即中奖。',
    example: '如：开奖冠军03、亚军04，和值为7，投注7即中奖。'
  },
  'pk10-ent-冠军': {
    title: '冠军',
    desc: '投注冠军名次的号码1～10或大小单双，与开奖第一名相符即中奖。',
    example: '如：投注冠军08，开奖第一名为08，即中奖。'
  },
  'pk10-ent-亚军': {
    title: '亚军',
    desc: '投注亚军名次的号码1～10或大小单双，与开奖第二名相符即中奖。',
    example: '如：投注亚军08，开奖第二名为08，即中奖。'
  },
  'pk10-ent-季军': {
    title: '季军',
    desc: '投注季军名次的号码1～10或大小单双，与开奖第三名相符即中奖。',
    example: '如：投注季军08，开奖第三名为08，即中奖。'
  },
  'pk10-ent-第四名': {
    title: '第四名',
    desc: '投注第四名的号码1～10或大小单双，与开奖第四名相符即中奖。',
    example: '如：投注第四名08，开奖第四名为08，即中奖。'
  },
  'pk10-ent-第五名': {
    title: '第五名',
    desc: '投注第五名的号码1～10或大小单双，与开奖第五名相符即中奖。',
    example: '如：投注第五名08，开奖第五名为08，即中奖。'
  },
  'pk10-ent-第六-十名': {
    title: '第六-十名',
    desc: '对第六名至第十名分别投注号码或大小单双，对应名次开奖结果相符即中奖。',
    example: '如：第六名投注08，开奖第六名为08，即中奖。'
  },
  'pk10-ent-龙虎斗': {
    title: '龙虎斗',
    desc: '比较指定两个名次的车号大小，前者大为【龙】，后者大为【虎】。',
    example: '如：1v10投注龙，开奖第一名08、第十名03，即中奖。'
  },
  'pk10-ent-番摊': {
    title: '番摊',
    desc: '开奖前三名号码相加后除以4，余数为番数（整除为4番）。可投注番、念、角及大小单双。',
    example: '如：开奖3、4、2，和为9，9÷4余1，开出1番。'
  }
}

const buildPlayHelp = (play, fallbackName) => {
  const title = play?.playName || fallbackName || '玩法说明'
  const names = (play?.positions || []).map((p) => p.name).filter(Boolean)
  if (play?.choiceOptions?.length) {
    const first = play.choiceOptions[0]
    return {
      title,
      desc: `从「${title}」中选择 ${play.choiceOptions.join('、')}，与开奖结果相符即中奖。`,
      example: `如：投注「${first}」，开奖结果为「${first}」，即中奖。`
    }
  }
  if (play?.layout === 'sum') {
    return {
      title,
      desc: `选择一个和值，与开奖对应位置号码之和相同即中奖。`,
      example: `投注和值与开奖号码对应位置之和一致，即中「${title}」。`
    }
  }
  if (play?.mode === 'position' && names.length) {
    return {
      title,
      desc: `在${names.join('、')}任意位置选择号码，该位置开奖号码与所选号码相同即中奖。`,
      example: `如：在${names[0]}选择一个号码，开奖该位置号码相同，即中「${title}」。`
    }
  }
  if (play?.unique && names.length > 1) {
    return {
      title,
      desc: `从${names.join('、')}各选1个不重复号码，顺序与开奖一致即中奖。`,
      example: `所选号码按位置与开奖号码相同，即中「${title}」。`
    }
  }
  if (play?.layout === 'text') {
    const sample = String(play.placeholder || '').split('\n').find((line) => /\d/.test(line)) || ''
    return {
      title,
      desc: `手动输入号码组成注单，格式与开奖号码对应位置相同即中奖。`,
      example: sample ? `输入格式示例：${sample}` : `按页面提示输入号码，与开奖对应位置相同即中「${title}」。`
    }
  }
  if (names.length === 1) {
    return {
      title,
      desc: `从${names[0]}选择号码，与开奖对应位置相同即中奖。`,
      example: `如：投注号码与开奖${names[0]}相同，即中「${title}」。`
    }
  }
  if (names.length > 1) {
    return {
      title,
      desc: `从${names.join('、')}选择号码组成注单，与开奖对应位置相同即中奖。`,
      example: `所选号码均与开奖对应位置相符，即中「${title}」。`
    }
  }
  return {
    title,
    desc: `投注「${title}」，所选内容与开奖结果相符即中奖。`,
    example: '请按页面选项投注，开奖后系统自动兑奖。'
  }
}

export const getPlayHelp = ({ playKey, play, quickSide, isPk10Quick } = {}) => {
  if (isPk10Quick && quickSide && PLAY_HELP[`pk10-ent-${quickSide}`]) {
    return PLAY_HELP[`pk10-ent-${quickSide}`]
  }
  if (playKey && PLAY_HELP[playKey]) return PLAY_HELP[playKey]
  return buildPlayHelp(play, quickSide)
}

export const LOTTERY_HELP = {
  PK10: {
    schedules: [
      { time: '00:00:00~04:58:30', freq: '每天200期，1分30秒一期' },
      { time: '06:00:00~23:58:30', freq: '每天720期，1分30秒一期' }
    ],
    official: 'https://lotteryxz.com',
    url: 'https://278250.com/#/PK10/TCSPK10/'
  },
  10403: {
    schedules: [
      { time: '00:00:00~23:59:00', freq: '每天1440期，1分一期' }
    ],
    official: '',
    url: 'https://278250.com/#/PK10/TCG1FPK10/'
  }
}

const QUICK_FAV = { key: 'quickfav', name: '快捷玩法', quick: true, children: [] }

const PK10_OFFICIAL_MENU = [
  QUICK_FAV,
  { key: 'front1', name: '猜前一', children: [{ key: 'pk10-front1', name: '猜前一' }] },
  {
    key: 'front2',
    name: '猜前二',
    children: [
      { key: 'pk10-front2', name: '猜前二' },
      { key: 'pk10-front2-ds', name: '猜前二 (单式)' }
    ]
  },
  {
    key: 'front3',
    name: '猜前三',
    children: [
      { key: 'pk10-front3', name: '猜前三' },
      { key: 'pk10-front3-ds', name: '猜前三（单式）' }
    ]
  },
  {
    key: 'front4',
    name: '猜前四',
    children: [
      { key: 'pk10-front4', name: '猜前四' },
      { key: 'pk10-front4-ds', name: '猜前四 (单式)' }
    ]
  },
  {
    key: 'front5',
    name: '猜前五',
    children: [
      { key: 'pk10-front5', name: '猜前五' },
      { key: 'pk10-front5-ds', name: '猜前五（单式）' }
    ]
  },
  {
    key: 'dw',
    name: '定位胆',
    children: [
      { key: 'pk10-dw-front5', name: '前五定位胆' },
      { key: 'pk10-dw-back5', name: '后五定位胆' }
    ]
  },
  {
    key: 'sum',
    name: '猜和值',
    children: [
      { key: 'pk10-sum-gy', name: '冠亚和值' },
      { key: 'pk10-sum-gyj', name: '冠亚季和值' },
      { key: 'pk10-sum-sw', name: '首尾和值' }
    ]
  },
  {
    key: 'dxds',
    name: '大小单双',
    children: [
      { key: 'pk10-dxds-front5', name: '前五大小单双' },
      { key: 'pk10-dxds-back5', name: '后五大小单双' },
      { key: 'pk10-dxds-gy', name: '冠亚和大小单双' }
    ]
  },
  {
    key: 'dt',
    name: '龙虎斗',
    children: [
      { key: 'pk10-dt-1v10', name: '第一名VS第十名' },
      { key: 'pk10-dt-2v9', name: '第二名VS第九名' },
      { key: 'pk10-dt-3v8', name: '第三名VS第八名' },
      { key: 'pk10-dt-4v7', name: '第四名VS第七名' },
      { key: 'pk10-dt-5v6', name: '第五名VS第六名' }
    ]
  }
]

const PK10_ENT_MENU = [
  QUICK_FAV,
  { key: 'ent-quick', name: '快捷', children: [{ key: 'pk10-快捷', name: '快捷' }] },
  { key: 'ent-two', name: '两面', children: [{ key: 'pk10-两面', name: '两面' }] },
  { key: 'ent-sum', name: '猜和值', children: [{ key: 'pk10-猜和值', name: '猜和值' }] },
  { key: 'ent-1', name: '冠军', children: [{ key: 'pk10-冠军', name: '冠军' }] },
  { key: 'ent-2', name: '亚军', children: [{ key: 'pk10-亚军', name: '亚军' }] },
  { key: 'ent-3', name: '季军', children: [{ key: 'pk10-季军', name: '季军' }] },
  { key: 'ent-4', name: '第四名', children: [{ key: 'pk10-第四名', name: '第四名' }] },
  { key: 'ent-5', name: '第五名', children: [{ key: 'pk10-第五名', name: '第五名' }] },
  { key: 'ent-6', name: '第六-十名', children: [{ key: 'pk10-第六-十名', name: '第六-十名' }] },
  { key: 'ent-dt', name: '龙虎斗', children: [{ key: 'pk10-龙虎斗', name: '龙虎斗' }] },
  { key: 'ent-ft', name: '番摊', children: [{ key: 'pk10-番摊', name: '番摊' }] }
]

export const PLAY_MENUS = {
  LF: {
    tradition: [
      QUICK_FAV,
      {
        key: 'front3',
        name: '前三',
        children: [
          { key: 'p3-zx', name: 'P3直选' },
          { key: 'p3-zx-ds', name: 'P3直选（单式）' },
          { key: 'p3-zx-sum', name: 'P3直选和值' },
          { key: 'p3-z3', name: 'P3组三' },
          { key: 'p3-z6', name: 'P3组六' },
          { key: 'p3-zx-group-sum', name: 'P3组选和值' },
          { key: 'p3-mix', name: 'P3混合组选' }
        ]
      },
      {
        key: 'front3-bdw',
        name: '前三不定位',
        children: [
          { key: 'p3-1d', name: 'P3一码不定位' },
          { key: 'p3-2d', name: 'P3二码不定位' }
        ]
      },
      {
        key: 'front2',
        name: '前二',
        children: [
          { key: 'front2-zx', name: '前二直选' },
          { key: 'front2-zux', name: '前二组选' }
        ]
      },
      {
        key: 'back2',
        name: '后二',
        children: [
          { key: 'p3-back2-zx', name: 'P3后二直选' },
          { key: 'p3-back2-zx-ds', name: 'P3后二直选（单式）' },
          { key: 'p3-back2-zux', name: 'P3后二组选' },
          { key: 'p5-back2-zx', name: 'P5后二直选' },
          { key: 'p5-back2-zx-ds', name: 'P5后二直选（单式）' },
          { key: 'p5-back2-zux', name: 'P5后二组选' }
        ]
      },
      {
        key: 'dxds',
        name: '大小单双',
        children: [
          { key: 'front2-dxds', name: '前二大小单双' },
          { key: 'p3-back2-dxds', name: 'P3后二大小单双' },
          { key: 'p5-back2-dxds', name: 'P5后二大小单双' }
        ]
      },
      { key: 'dw', name: '定位胆', children: [{ key: 'lf-dw', name: '定位胆' }] }
    ]
  },
  SSC: {
    tradition: [
      QUICK_FAV,
      { key: 'wx', name: '五星', children: [{ key: 'ssc-wx', name: '五星直选' }] },
      { key: 'q4', name: '前四', children: [{ key: 'ssc-q4', name: '前四直选' }] },
      { key: 'h4', name: '后四', children: [{ key: 'ssc-h4', name: '后四直选' }] },
      { key: 'q3', name: '前三', children: [{ key: 'ssc-q3', name: '前三直选' }] },
      { key: 'z3', name: '中三', children: [{ key: 'ssc-z3', name: '中三直选' }] },
      { key: 'h3', name: '后三', children: [{ key: 'ssc-h3', name: '后三直选' }] },
      { key: 'q2', name: '前二', children: [{ key: 'ssc-q2', name: '前二直选' }] },
      { key: 'h2', name: '后二', children: [{ key: 'ssc-h2', name: '后二直选' }] },
      { key: 'dw', name: '定位胆', children: [{ key: 'ssc-dw', name: '定位胆' }] },
      { key: 'bdw', name: '不定位', children: [{ key: 'ssc-bdw', name: '一码不定位' }] },
      { key: 'fun', name: '趣味', children: [{ key: 'ssc-dxds', name: '前二大小单双' }] },
      { key: 'dt', name: '龙虎和', children: [{ key: 'ssc-dt-12', name: '万vs千' }] },
      { key: 'rx', name: '任选', children: [{ key: 'ssc-rx2', name: '任二直选' }] }
    ],
    entertainment: [
      QUICK_FAV,
      {
        key: 'ssc-combine',
        name: '整合',
        children: [
          { key: 'ssc-b1', name: '第一球:直选' },
          { key: 'ssc-b1-dxds', name: '第一球:大小单双' },
          { key: 'ssc-b2', name: '第二球:直选' },
          { key: 'ssc-b2-dxds', name: '第二球:大小单双' },
          { key: 'ssc-b3', name: '第三球:直选' },
          { key: 'ssc-b3-dxds', name: '第三球:大小单双' },
          { key: 'ssc-b4', name: '第四球:直选' },
          { key: 'ssc-b4-dxds', name: '第四球:大小单双' },
          { key: 'ssc-b5', name: '第五球:直选' },
          { key: 'ssc-b5-dxds', name: '第五球:大小单双' }
        ]
      },
      {
        key: 'ssc-two',
        name: '两面盘',
        children: [
          { key: 'ssc-b1-dxds', name: '第一球:大小单双' },
          { key: 'ssc-b2-dxds', name: '第二球:大小单双' },
          { key: 'ssc-b3-dxds', name: '第三球:大小单双' },
          { key: 'ssc-b4-dxds', name: '第四球:大小单双' },
          { key: 'ssc-b5-dxds', name: '第五球:大小单双' },
          { key: 'ssc-ent-dxds', name: '总大小单双' }
        ]
      },
      {
        key: 'ssc-b1',
        name: '第一球',
        children: [
          { key: 'ssc-b1', name: '第一球:直选' },
          { key: 'ssc-b1-dxds', name: '第一球:大小单双' }
        ]
      },
      { key: 'ssc-b2', name: '第二球', children: [{ key: 'ssc-b2', name: '第二球:直选' }, { key: 'ssc-b2-dxds', name: '第二球:大小单双' }] },
      { key: 'ssc-b3', name: '第三球', children: [{ key: 'ssc-b3', name: '第三球:直选' }, { key: 'ssc-b3-dxds', name: '第三球:大小单双' }] },
      { key: 'ssc-b4', name: '第四球', children: [{ key: 'ssc-b4', name: '第四球:直选' }, { key: 'ssc-b4-dxds', name: '第四球:大小单双' }] },
      { key: 'ssc-b5', name: '第五球', children: [{ key: 'ssc-b5', name: '第五球:直选' }, { key: 'ssc-b5-dxds', name: '第五球:大小单双' }] },
      { key: 'ssc-dt', name: '龙虎斗', children: [{ key: 'ssc-dt-12', name: '第一球vs第二球' }] },
      { key: 'ssc-five1', name: '全五中一', children: [{ key: 'ssc-five1', name: '全五中一:直选' }] },
      { key: 'ssc-nn', name: '牛牛', children: [{ key: 'ssc-nn', name: '牛牛' }] },
      { key: 'ssc-hk5', name: '炸金花', children: [{ key: 'ssc-hk5', name: '炸金花' }] },
      { key: 'ssc-bjl', name: '百家乐', children: [{ key: 'ssc-bjl', name: '百家乐' }] }
    ]
  },
  PK10: {
    tradition: PK10_OFFICIAL_MENU,
    entertainment: PK10_ENT_MENU
  },
  K3: {
    tradition: [
      QUICK_FAV,
      { key: 'k3-sum', name: '和值', children: [{ key: 'k3-sum', name: '和值' }] },
      {
        key: 'k3-same3',
        name: '三同号',
        children: [
          { key: 'k3-same3', name: '三同号单选' },
          { key: 'k3-same3-all', name: '三同号通选' }
        ]
      },
      {
        key: 'k3-diff3',
        name: '三不同号',
        children: [
          { key: 'k3-diff3', name: '三不同号' },
          { key: 'k3-diff3-all', name: '三不同号通选' }
        ]
      },
      { key: 'k3-straight', name: '三连号', children: [{ key: 'k3-straight', name: '三连号通选' }] },
      {
        key: 'k3-same2',
        name: '二同号',
        children: [
          { key: 'k3-same2-single', name: '二同号单选' },
          { key: 'k3-same2', name: '二同号复选' },
          { key: 'k3-same2-all', name: '二同号通选' }
        ]
      },
      { key: 'k3-diff2', name: '二不同号', children: [{ key: 'k3-diff2', name: '二不同号' }] },
      {
        key: 'k3-fun',
        name: '趣味',
        children: [
          { key: 'k3-fun-bs', name: '和值大小单双' },
          { key: 'k3-fun-com', name: '和值组合大小单双' }
        ]
      },
      {
        key: 'k3-solo',
        name: '单挑一骰',
        children: [
          { key: 'k3-guess-in', name: '猜必出' },
          { key: 'k3-guess-out', name: '猜必不出' }
        ]
      },
      { key: 'k3-span', name: '跨度', children: [{ key: 'k3-span', name: '跨度' }] },
      {
        key: 'k3-showhand',
        name: '梭哈',
        children: [
          { key: 'k3-sh-baozi', name: '豹子' },
          { key: 'k3-sh-qs', name: '全顺' },
          { key: 'k3-sh-dz', name: '对子' },
          { key: 'k3-sh-bs', name: '半顺' },
          { key: 'k3-sh-zs', name: '杂三' }
        ]
      }
    ]
  },
  '11X5': {
    tradition: [
      QUICK_FAV,
      {
        key: 'x5-rx',
        name: '任选',
        children: [
          { key: 'x5-r1', name: '任选一' },
          { key: 'x5-r2', name: '任选二' },
          { key: 'x5-r3', name: '任选三' },
          { key: 'x5-r4', name: '任选四' },
          { key: 'x5-r5', name: '任选五' }
        ]
      },
      { key: 'x5-dds', name: '定单双', children: [{ key: 'x5-dds', name: '定单双' }] },
      { key: 'x5-mid', name: '猜中位', children: [{ key: 'x5-mid', name: '猜中位' }] },
      {
        key: 'x5-q3',
        name: '前三',
        children: [
          { key: 'x5-q3-zx', name: '前三直选' },
          { key: 'x5-q3-zux', name: '前三组选' }
        ]
      },
      {
        key: 'x5-q2',
        name: '前二',
        children: [
          { key: 'x5-q2-zx', name: '前二直选' },
          { key: 'x5-q2-zux', name: '前二组选' }
        ]
      },
      { key: 'x5-bdw', name: '不定位', children: [{ key: 'x5-bdw', name: '前三不定位' }] },
      { key: 'x5-dw', name: '定位胆', children: [{ key: 'x5-dw', name: '定位胆' }] }
    ],
    entertainment: [
      QUICK_FAV,
      { key: 'x5-ent-two', name: '两面', children: [{ key: 'x5-two', name: '两面' }] },
      { key: 'x5-ent-b1', name: '第一球', children: [{ key: 'x5-b1', name: '第一球' }] }
    ]
  },
  LHC: {
    entertainment: [
      QUICK_FAV,
      { key: 'lhc-tm', name: '特码', children: [{ key: 'lhc-tm', name: '特码' }, { key: 'lhc-tm-dxds', name: '特码两面' }] },
      { key: 'lhc-two', name: '两面', children: [{ key: 'lhc-tm-dxds', name: '特码两面' }] },
      { key: 'lhc-sb', name: '色波', children: [{ key: 'lhc-sb', name: '色波' }] },
      { key: 'lhc-sx', name: '特肖', children: [{ key: 'lhc-sx', name: '特肖' }] },
      { key: 'lhc-tw', name: '头尾数', children: [{ key: 'lhc-tw', name: '头尾数' }] },
      { key: 'lhc-hx', name: '合肖', children: [{ key: 'lhc-hx', name: '合肖' }] },
      { key: 'lhc-zm', name: '正码', children: [{ key: 'lhc-zm', name: '正码' }] },
      { key: 'lhc-zmdw', name: '正码定位', children: [{ key: 'lhc-zm1', name: '正码一' }] },
      { key: 'lhc-zm16', name: '正码1-6', children: [{ key: 'lhc-zm1', name: '正码一' }] },
      {
        key: 'lhc-lm',
        name: '连码',
        children: [
          { key: 'lhc-lm-2', name: '二全中' },
          { key: 'lhc-lm-3', name: '三全中' },
          { key: 'lhc-lm-4', name: '四全中' },
          { key: 'lhc-lm-3z2', name: '三中二' },
          { key: 'lhc-lm-2z2', name: '二中特' },
          { key: 'lhc-lm-t2', name: '特串' }
        ]
      },
      {
        key: 'lhc-lx', name: '连肖', children: [
          { key: 'lhc-lx2', name: '二连肖' },
          { key: 'lhc-lx3', name: '三连肖' },
          { key: 'lhc-lx4', name: '四连肖' },
          { key: 'lhc-lx5', name: '五连肖' }
        ]
      },
      { key: 'lhc-zx', name: '自选不中', children: [{ key: 'lhc-zx', name: '自选不中' }] }
    ]
  },
  KENO: {
    tradition: [
      QUICK_FAV,
      {
        key: 'keno-rx',
        name: '任选',
        children: [
          { key: 'keno-r1', name: '任选一' },
          { key: 'keno-r2', name: '任选二' },
          { key: 'keno-r3', name: '任选三' }
        ]
      },
      {
        key: 'keno-fun',
        name: '趣味',
        children: [
          { key: 'keno-updown', name: '上下盘' },
          { key: 'keno-oe', name: '奇偶盘' }
        ]
      }
    ]
  },
  PCB: {
    entertainment: [
      QUICK_FAV,
      { key: 'pcb-sum', name: '和值', children: [{ key: 'pcb-sum', name: '和值' }] },
      { key: 'pcb-dxds', name: '两面', children: [{ key: 'pcb-dxds', name: '大小单双' }] },
      { key: 'pcb-combo', name: '组合', children: [{ key: 'pcb-combo', name: '组合大小单双' }] }
    ]
  }
}

export const PLAY_MODE_TABS = [
  { key: 'tradition', name: '官方' },
  { key: 'entertainment', name: '娱乐城' }
]

const resolvePlayPack = (game) => {
  const id = Number(game?.id)
  if (GAME_PLAY_MENUS[id]) return GAME_PLAY_MENUS[id]
  return PLAY_MENUS[game?.group] || PLAY_MENUS.LF
}

export const GAME_PLAY_MENUS = {
  1802: PLAY_MENUS.PK10,
  10403: PLAY_MENUS.PK10
}

export const getPlayModes = (game) => {
  const pack = resolvePlayPack(game)
  if (!pack) return ['tradition']
  return PLAY_MODE_TABS.map((t) => t.key).filter((key) => pack[key]?.length)
}

export const defaultPlayMode = (game) => {
  const modes = getPlayModes(game)
  if (game?.group === 'PK10' || game?.group === 'PCB' || game?.group === 'LHC') {
    return modes.includes('entertainment') ? 'entertainment' : modes[0]
  }
  return modes[0] || 'tradition'
}

export const getPlayMenu = (game, mode) => {
  const pack = resolvePlayPack(game)
  const useMode = mode || defaultPlayMode(game)
  return pack[useMode] || pack.tradition || pack.entertainment || PLAY_MENUS.LF.tradition
}

export const defaultPlayKey = (game, mode) => {
  const groups = getPlayMenu(game, mode)
  const first = groups.find((g) => !g.quick && g.children?.length)
  return first?.children?.[0]?.key || 'p3-zx'
}

export const getPlayConfig = (game, playKey) => {
  if (playKey && PLAY_SPECS[playKey]) return PLAY_SPECS[playKey]
  if (game?.group === 'PK10') {
    return {
      layout: 'sum',
      playName: '冠亚季和值',
      posName: '冠亚季和',
      options: GYJH_OPTIONS,
      cols: 4,
      prize: GYJH_OPTIONS[0].odds,
      showMiss: false,
      showLimit: false,
      colored: true
    }
  }
  if (game?.group === 'SSC') return PLAY_SPECS['ssc-dw']
  if (game?.group === 'K3') return PLAY_SPECS['k3-sum']
  if (game?.group === '11X5') return PLAY_SPECS['x5-dw']
  if (game?.group === 'LHC') return PLAY_SPECS['lhc-tm']
  if (game?.group === 'KENO') return PLAY_SPECS['keno-r1']
  if (game?.group === 'PCB') return PLAY_SPECS['pcb-sum']
  return PLAY_SPECS['p3-zx']
}

export const PK10_RANK_ODDS = 9.8

export const PK10_RANK_SIDE_MAP = {
  冠军: [0],
  亚军: [1],
  季军: [2],
  第四名: [3],
  第五名: [4],
  '第六-十名': [5, 6, 7, 8, 9]
}

export const PK10_RANK_NUMS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export const pk10BallColor = (n) => PK10_BALL_COLORS[Number(n)] || '#888'

export const PK10_RANKS = ['冠军', '亚军', '季军', '第四名', '第五名', '第六名', '第七名', '第八名', '第九名', '第十名']

export const PK10_SIDES = ['快捷', '两面', '猜和值', '冠军', '亚军', '季军', '第四名', '第五名', '第六-十名', '龙虎斗', '番摊']

export const PK10_QUICK_BETS = [
  { key: 'n1', label: '1', num: 1 },
  { key: 'n2', label: '2', num: 2 },
  { key: 'n3', label: '3', num: 3 },
  { key: 'n4', label: '4', num: 4 },
  { key: 'n5', label: '5', num: 5 },
  { key: 'n6', label: '6', num: 6 },
  { key: 'n7', label: '7', num: 7 },
  { key: 'n8', label: '8', num: 8 },
  { key: 'n9', label: '9', num: 9 },
  { key: 'n10', label: '10', num: 10 },
  { key: 'big', label: '大' },
  { key: 'small', label: '小' },
  { key: 'odd', label: '单' },
  { key: 'even', label: '双' }
]

const twoSidePair = (i) => `${i + 1}v${10 - i}`

export const PK10_TWO_SIDE_SECTIONS = [
  {
    title: '冠亚和大小单双',
    items: [
      { key: 'gy-big', label: '大', odds: 2.2 },
      { key: 'gy-small', label: '小', odds: 1.76 },
      { key: 'gy-odd', label: '单', odds: 1.96 },
      { key: 'gy-even', label: '双', odds: 1.96 }
    ]
  },
  ...PK10_RANKS.map((title, i) => {
    const items = [
      { key: `r${i}-big`, label: '大', odds: 1.96 },
      { key: `r${i}-small`, label: '小', odds: 1.96 },
      { key: `r${i}-odd`, label: '单', odds: 1.96 },
      { key: `r${i}-even`, label: '双', odds: 1.96 }
    ]
    if (i < 5) {
      items.push(
        { key: `r${i}-dragon`, label: '龙', pair: twoSidePair(i), odds: 1.96, tone: 'dragon' },
        { key: `r${i}-tiger`, label: '虎', pair: twoSidePair(i), odds: 1.96, tone: 'tiger' }
      )
    }
    return { title, items }
  })
]

export const PK10_DT_SECTIONS = PK10_RANKS.slice(0, 5).map((title, i) => ({
  title: `${title} vs ${PK10_RANKS[9 - i]}`,
  items: [
    { key: `dt${i}-dragon`, label: '龙', odds: 1.96, tone: 'dragon' },
    { key: `dt${i}-tiger`, label: '虎', odds: 1.96, tone: 'tiger' }
  ]
}))

export const pk10AttrSummary = (codes) => {
  if (!codes || codes.length < 10) return []
  const sum = Number(codes[0]) + Number(codes[1])
  const tags = [
    { type: 'sum', text: String(sum) },
    { type: 'tag', text: sum >= 12 ? '大' : '小' },
    { type: 'tag', text: sum % 2 ? '单' : '双' }
  ]
  for (let i = 0; i < 5; i++) {
    tags.push({ type: 'tag', text: Number(codes[i]) > Number(codes[9 - i]) ? '龙' : '虎' })
  }
  return tags
}

const pk10RankSize = (n) => (Number(n) >= 6 ? '大' : '小')
const pk10RankParity = (n) => (Number(n) % 2 ? '单' : '双')

export const PK10_ROAD_TYPES = [
  { key: 'size', label: '大小' },
  { key: 'parity', label: '单双' },
  { key: 'dt', label: '龙虎' }
]

const outcomeOf = (draw, type, rank = 0) => {
  const codes = draw.codes || []
  if (type === 'size') return pk10RankSize(codes[rank])
  if (type === 'parity') return pk10RankParity(codes[rank])
  const a = Number(codes[rank])
  const b = Number(codes[9 - rank])
  if (!a || !b) return ''
  return a > b ? '龙' : '虎'
}

export const buildPk10BeadPlate = (draws, type = 'size', rank = 0, rows = 6) => {
  const values = [...draws].reverse().map((d) => outcomeOf(d, type, rank)).filter(Boolean)
  const cols = Math.max(10, Math.ceil(values.length / rows))
  const grid = Array.from({ length: rows }, () => Array(cols).fill(''))
  values.forEach((v, i) => {
    grid[i % rows][Math.floor(i / rows)] = v
  })
  return grid
}

export const ROAD_MAIN_TABS = [
  { key: 'sum', label: '整合' },
  { key: 'dt', label: '龙虎斗' }
]

export const ROAD_SUM_FILTERS = [
  { key: 'gy-sum', label: '冠亚和值' },
  { key: 'gy-oe', label: '冠亚和单双' },
  { key: 'gy-bs', label: '冠亚和大小' }
]

export const ROAD_DT_FILTERS = [
  { key: '0', label: '1VS10' },
  { key: '1', label: '2VS9' },
  { key: '2', label: '3VS8' },
  { key: '3', label: '4VS7' },
  { key: '4', label: '5VS6' }
]

export const pk10RoadItems = (draws, filter) => {
  const chrono = [...(draws || [])].reverse()
  return chrono.map((d) => {
    const codes = d.codes || []
    if (filter === 'gy-sum' || filter === 'gy-oe' || filter === 'gy-bs') {
      const sum = Number(codes[0]) + Number(codes[1])
      if (filter === 'gy-sum') {
        return { text: String(sum), key: String(sum), tone: sum % 2 ? 'blue' : 'red' }
      }
      if (filter === 'gy-oe') {
        const key = sum % 2 ? '单' : '双'
        return { text: key, key, tone: key === '单' ? 'red' : 'blue' }
      }
      const key = sum >= 12 ? '大' : '小'
      return { text: key, key, tone: key === '大' ? 'red' : 'blue' }
    }
    const i = Number(filter) || 0
    const key = Number(codes[i]) > Number(codes[9 - i]) ? '龙' : '虎'
    return { text: key, key, tone: key === '龙' ? 'red' : 'blue' }
  }).filter((x) => x.text)
}

export const buildPk10BigRoad = (items, rows = 6, cols = 45) => {
  const grid = Array.from({ length: rows }, () => Array.from({ length: cols }, () => null))
  const empty = (r, c) => r >= 0 && r < rows && c >= 0 && c < cols && !grid[r][c]
  const firstEmptyCol = () => {
    for (let c = 0; c < cols; c += 1) if (!grid[0][c]) return c
    return cols
  }
  let r = 0
  let c = 0
  let canDown = true
  items.forEach((item, i) => {
    if (i === 0) {
      grid[0][0] = item
      return
    }
    if (item.key === items[i - 1].key) {
      if (r === rows - 1) c += 1
      else if (empty(r + 1, c) && canDown) r += 1
      else {
        c += 1
        canDown = false
      }
    } else {
      r = 0
      c = firstEmptyCol()
      canDown = true
    }
    if (c < cols && empty(r, c)) grid[r][c] = item
  })
  return grid
}

export const buildPk10BeadBoard = (items, rows = 6, cols = 45) => {
  const grid = Array.from({ length: rows }, () => Array.from({ length: cols }, () => null))
  items.forEach((item, i) => {
    const r = i % rows
    const c = Math.floor(i / rows)
    if (c < cols) grid[r][c] = item
  })
  return grid
}

export const ROAD_MAIN_TABS_K3 = [
  { key: 'sum', label: '整合' },
  { key: 'lhh', label: '龙虎和' }
]

export const ROAD_SUM_FILTERS_K3 = [
  { key: 'b0', label: '第一球' },
  { key: 'b1', label: '第二球' },
  { key: 'b2', label: '第三球' },
  { key: 'hz', label: '和值' },
  { key: 'span', label: '跨度' }
]

export const ROAD_LHH_FILTERS_K3 = [
  { key: '12', label: '一球vs二球' },
  { key: '13', label: '一球vs三球' },
  { key: '23', label: '二球vs三球' }
]

const k3ToneByNum = (n) => (Number(n) % 2 ? 'blue' : 'red')

export const generateK3Draws = (gameId, count = 60) => {
  const list = []
  let issue = 14450100
  let seed = (Number(gameId) || 1909) * 9973 + 17
  const next = () => {
    seed = (seed * 1103515245 + 12345) & 0x7fffffff
    return (seed % 6) + 1
  }
  for (let i = 0; i < count; i += 1) {
    list.push({
      issue: String(issue - i),
      numero: String(issue - i),
      codes: [next(), next(), next()]
    })
  }
  return list
}

export const k3RoadItems = (draws, filter) => {
  const chrono = [...(draws || [])].reverse()
  return chrono.map((d) => {
    const codes = (d.codes || []).map((n) => Number(n) || 0)
    if (filter === 'b0' || filter === 'b1' || filter === 'b2') {
      const n = codes[Number(filter.slice(1))] || 0
      if (!n) return null
      return { text: String(n), key: String(n), tone: k3ToneByNum(n) }
    }
    if (filter === 'hz') {
      const sum = codes.slice(0, 3).reduce((a, b) => a + b, 0)
      if (!sum) return null
      return { text: String(sum), key: String(sum), tone: k3ToneByNum(sum) }
    }
    if (filter === 'span') {
      const slice = codes.slice(0, 3).filter(Boolean)
      if (slice.length < 3) return null
      const span = Math.max(...slice) - Math.min(...slice)
      return { text: String(span), key: String(span), tone: k3ToneByNum(span) }
    }
    if (filter === '12' || filter === '13' || filter === '23') {
      const a = codes[Number(filter[0]) - 1]
      const b = codes[Number(filter[1]) - 1]
      if (!a || !b) return null
      if (a === b) return { text: '和', key: '和', tone: 'green' }
      const key = a > b ? '龙' : '虎'
      return { text: key, key, tone: key === '龙' ? 'red' : 'blue' }
    }
    return null
  }).filter(Boolean)
}

export const PK10_LONG_PERIODS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export const PK10_MISS_CATS = [
  { key: 'gy', label: '冠亚和值' },
  { key: 'gyj', label: '冠亚季和值' },
  { key: 'sw', label: '首尾和值' },
  ...PK10_RANKS.map((label, i) => ({ key: `r${i}`, label, rank: i })),
  { key: 'dt', label: '龙虎斗' }
]

const LONG_OPPOSITE = { 大: '小', 小: '大', 单: '双', 双: '单', 龙: '虎', 虎: '龙' }

export const buildPk10LongDragons = (draws, min = 2, mode = 'hit') => {
  if (!draws?.length) return []
  const items = []
  const addStreak = (name, play, getter) => {
    const first = getter(draws[0])
    if (!first) return
    let n = 0
    for (const d of draws) {
      if (getter(d) !== first) break
      n += 1
    }
    if (n < min) return
    const mark = mode === 'miss' ? (LONG_OPPOSITE[first] || first) : first
    items.push({
      name,
      play,
      mark,
      count: n,
      title: play ? `${name}:${play}` : name,
      key: `${name}-${play || 'dt'}-${mark}`
    })
  }
  PK10_RANKS.forEach((name, i) => {
    addStreak(name, '大小单双', (d) => pk10RankSize(d.codes[i]))
    addStreak(name, '大小单双', (d) => pk10RankParity(d.codes[i]))
  })
  addStreak('冠亚和', '大小单双', (d) => {
    const s = Number(d.codes[0]) + Number(d.codes[1])
    return s >= 12 ? '大' : '小'
  })
  addStreak('冠亚和', '大小单双', (d) => {
    const s = Number(d.codes[0]) + Number(d.codes[1])
    return s % 2 ? '单' : '双'
  })
  for (let i = 0; i < 5; i++) {
    addStreak(`${PK10_RANKS[i]}vs${PK10_RANKS[9 - i]}`, '', (d) => (
      Number(d.codes[i]) > Number(d.codes[9 - i]) ? '龙' : '虎'
    ))
  }
  return items.sort((a, b) => b.count - a.count || a.title.localeCompare(b.title, 'zh'))
}

const missCount = (draws, getter, mark) => {
  let n = 0
  for (const d of draws) {
    if (getter(d) === mark) break
    n += 1
  }
  return n
}

export const buildPk10MissRank = (draws, catKey = 'gy') => {
  if (!draws?.length) return []
  const cat = PK10_MISS_CATS.find((c) => c.key === catKey) || PK10_MISS_CATS[0]
  const items = []
  const push = (mark, getter) => {
    const n = missCount(draws, getter, mark)
    if (n <= 0) return
    items.push({
      key: `${cat.key}-${mark}`,
      title: cat.label,
      mark,
      count: n
    })
  }
  if (cat.key === 'gy') {
    const getter = (d) => Number(d.codes[0]) + Number(d.codes[1])
    for (let s = 3; s <= 19; s++) push(s, getter)
  } else if (cat.key === 'gyj') {
    const getter = (d) => Number(d.codes[0]) + Number(d.codes[1]) + Number(d.codes[2])
    for (let s = 6; s <= 27; s++) push(s, getter)
  } else if (cat.key === 'sw') {
    const getter = (d) => Number(d.codes[0]) + Number(d.codes[9])
    for (let s = 3; s <= 19; s++) push(s, getter)
  } else if (cat.key === 'dt') {
    const getter = (d) => (Number(d.codes[0]) > Number(d.codes[9]) ? '龙' : '虎')
    push('龙', getter)
    push('虎', getter)
  } else if (cat.rank != null) {
    const i = cat.rank
    const getter = (d) => Number(d.codes[i])
    for (let n = 1; n <= 10; n++) push(n, getter)
  }
  return items.sort((a, b) => b.count - a.count || String(a.mark).localeCompare(String(b.mark), 'zh'))
}

export const K3_LONG_PERIODS = [1, 2, 3, 4, 5, 6]

export const K3_MISS_CATS = [
  { key: 'hz', label: '和值' },
  { key: 'bs', label: '和值大小单双' },
  { key: 'pair2', label: '两连' },
  { key: 'solo', label: '独胆' },
  { key: 'baozi', label: '豹子' },
  { key: 'duizi', label: '对子' }
]

const k3Codes = (d) => (d?.codes || []).slice(0, 3).map((n) => Number(n) || 0).filter((n) => n >= 1 && n <= 6)
const k3Sum = (d) => k3Codes(d).reduce((a, b) => a + b, 0)
const k3Span = (d) => {
  const c = k3Codes(d)
  if (c.length < 3) return null
  return Math.max(...c) - Math.min(...c)
}

export const buildK3LongDragons = (draws, min = 2) => {
  if (!draws?.length) return []
  const items = []
  const addStreak = (title, getter) => {
    const first = getter(draws[0])
    if (first == null || first === '') return
    let n = 0
    for (const d of draws) {
      if (getter(d) !== first) break
      n += 1
    }
    if (n < min) return
    items.push({
      key: `${title}-${first}`,
      title,
      mark: first,
      count: n
    })
  }

  addStreak('和值大小单双', (d) => {
    const s = k3Sum(d)
    return s ? (s >= 11 ? '大' : '小') : null
  })
  addStreak('和值大小单双', (d) => {
    const s = k3Sum(d)
    return s ? (s % 2 ? '单' : '双') : null
  })
  for (let n = 1; n <= 6; n += 1) {
    addStreak('独胆', (d) => (k3Codes(d).includes(n) ? String(n) : null))
    addStreak('不出胆', (d) => {
      const c = k3Codes(d)
      if (c.length < 3) return null
      return c.includes(n) ? null : String(n)
    })
  }
  ;[
    ['一球vs二球', 0, 1],
    ['一球vs三球', 0, 2],
    ['二球vs三球', 1, 2]
  ].forEach(([title, i, j]) => {
    addStreak(title, (d) => {
      const c = k3Codes(d)
      if (c.length < 3) return null
      if (c[i] === c[j]) return '和'
      return c[i] > c[j] ? '龙' : '虎'
    })
  })
  addStreak('跨度', (d) => {
    const sp = k3Span(d)
    return sp == null ? null : String(sp)
  })

  return items.sort((a, b) => b.count - a.count || a.title.localeCompare(b.title, 'zh'))
}

export const buildK3MissRank = (draws, catKey = 'hz') => {
  if (!draws?.length) return []
  const cat = K3_MISS_CATS.find((c) => c.key === catKey) || K3_MISS_CATS[0]
  const items = []
  const push = (mark, getter) => {
    const n = missCount(draws, getter, mark)
    if (n <= 0) return
    items.push({
      key: `${cat.key}-${mark}`,
      title: cat.label,
      mark,
      count: n
    })
  }

  if (cat.key === 'hz') {
    const getter = (d) => k3Sum(d)
    for (let s = 3; s <= 18; s += 1) push(s, getter)
  } else if (cat.key === 'bs') {
    ;['大', '小', '单', '双'].forEach((m) => {
      push(m, (d) => {
        const s = k3Sum(d)
        if (!s) return null
        if (m === '大' || m === '小') return s >= 11 ? '大' : '小'
        return s % 2 ? '单' : '双'
      })
    })
  } else if (cat.key === 'pair2') {
    const pairs = ['1|2', '1|3', '1|4', '1|5', '1|6', '2|3', '2|4', '2|5', '2|6', '3|4', '3|5', '3|6', '4|5', '4|6', '5|6']
    pairs.forEach((p) => {
      const [a, b] = p.split('|').map(Number)
      push(p, (d) => {
        const set = new Set(k3Codes(d))
        return set.has(a) && set.has(b) ? p : null
      })
    })
  } else if (cat.key === 'solo') {
    for (let n = 1; n <= 6; n += 1) {
      push(String(n), (d) => (k3Codes(d).includes(n) ? String(n) : null))
    }
  } else if (cat.key === 'baozi') {
    for (let n = 1; n <= 6; n += 1) {
      const mark = `${n}|${n}|${n}`
      push(mark, (d) => {
        const c = k3Codes(d)
        if (c.length < 3) return null
        return c[0] === n && c[1] === n && c[2] === n ? mark : null
      })
    }
    push('任意豹子', (d) => {
      const c = k3Codes(d)
      if (c.length < 3) return null
      return c[0] === c[1] && c[1] === c[2] ? '任意豹子' : null
    })
  } else if (cat.key === 'duizi') {
    for (let n = 1; n <= 6; n += 1) {
      const mark = `${n}|${n}`
      push(mark, (d) => {
        const c = k3Codes(d)
        return c.filter((x) => x === n).length >= 2 ? mark : null
      })
    }
  }

  return items.sort((a, b) => b.count - a.count || String(a.mark).localeCompare(String(b.mark), 'zh'))
}
